import { render, staticRenderFns } from "./ElementList.vue?vue&type=template&id=5ad8c1ea&scoped=true"
import script from "./ElementList.vue?vue&type=script&lang=js"
export * from "./ElementList.vue?vue&type=script&lang=js"
import style0 from "./ElementList.vue?vue&type=style&index=0&id=5ad8c1ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad8c1ea",
  null
  
)

export default component.exports